// Toggle primitive — pattern from design/v3/SettingsExtraSections.jsx:117-128
// (자동발주 켜기/끄기 버튼). Standalone switch UI.

import type { CSSProperties } from 'react';

export interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  style?: CSSProperties;
}

export function Toggle({ checked, onChange, label, disabled, style }: ToggleProps) {
  return (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        userSelect: 'none',
        ...style,
      }}
    >
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => !disabled && onChange(!checked)}
        style={{
          width: 36,
          height: 20,
          borderRadius: 'var(--radius-full)',
          background: checked ? 'var(--primary-strong)' : 'var(--border-base)',
          border: '1px solid',
          borderColor: checked ? 'var(--primary-strong)' : 'var(--border-base)',
          padding: 0,
          position: 'relative',
          cursor: disabled ? 'not-allowed' : 'pointer',
          transition: 'background var(--dur-base) var(--ease-out)',
          flexShrink: 0,
        }}
      >
        <span
          aria-hidden
          style={{
            position: 'absolute',
            top: 1,
            left: checked ? 17 : 1,
            width: 16,
            height: 16,
            borderRadius: 'var(--radius-full)',
            background: 'var(--bg-surface)',
            boxShadow: 'var(--shadow-xs)',
            transition: 'left var(--dur-base) var(--ease-out)',
          }}
        />
      </button>
      {label && (
        <span style={{ fontSize: 13, color: 'var(--fg-1)', fontFamily: 'var(--font-sans)' }}>
          {label}
        </span>
      )}
    </label>
  );
}
